// extracted by mini-css-extract-plugin
export default {"formRow":"DZZv7nWKtIkdQiP4CZj7","supBox":"ID9eBeAE9Yh16UAE0rJA"};